export const Bio = {
    name: "Suman Ghimire",
    roles: [
      "Software Developer",
      "Game Developer",
      "Freelancer",
      "Traveller",
    ],
    description:
      "I am a motivated developer trying to learn new technologies every single day",
    github: "https://github.com/suman-ghimire",
    resume:
      "https://sumang.com.np",
    linkedin: "https://www.linkedin.com/in/suman-ghimire1/",
    insta: "https://www.instagram.com/me.suman/",
    facebook: "https://www.facebook.com/xuman.g/",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Material UI",
          image:
            "data:image/png;base64,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",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Java",
          image: "https://classes.engineering.wustl.edu/cse231/core/images/2/26/Java.png",
        },
        {
          name: "SpringBoot",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/7/79/Spring_Boot.svg",
        },
        {
          name: "Kafka",
          image:
            "https://cdn.icon-icons.com/icons2/2699/PNG/512/apache_kafka_vertical_logo_icon_169585.png",
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        }
      ],
    },
    {
      title: "Game Development",
      skills: [
        {
          name: "Unity",
          image:
            "https://cdn.sanity.io/images/fuvbjjlp/production/aa5ce86e0add266e09ffa222609af4cc94befc7b-250x282.png",
        },
        {
          name: "BuildBox",
          image:
            "https://cdn-wordpress-2.buildbox.com/wp-content/uploads/2020/04/Buildbox-logo.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg",
        },
        {
          name: "Kubernetes",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/3/39/Kubernetes_logo_without_workmark.svg",
        },
        {
          name: "Jmeter",
          image:
            "https://www.simplilearn.com/ice9/free_resources_article_thumb/JMeter_Logo.png",
        },
        {
          name: "Postman",
          image:
            "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/postman-icon.png",
        },
        {
          name: "Datadog",
          image:
            "https://upload.wikimedia.org/wikipedia/en/thumb/7/7e/Datadog_logo.svg/1200px-Datadog_logo.svg.png",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://mma.prnewswire.com/media/76092/charter_communications_logo.jpg?w=200",
      role: "Software Developer",
      company: "Charter Communications",
      date: "May 2021 - Current",
      desc: "Working as a backend software developer.",
      skills: [
        "Java",
        "Springboot",
        "Hibernate",
        "kafka",
        "Redis",
        "Kubernetes",
        "Sql",
        "MongoDB"
      ],
    },
    {
      id: 1,
      img: "https://www.mikecritelli.com/content/images/2022/05/pitney-bowes-logo-thumb.png",
      role: "Full Stack Developer",
      company: "Pitney Bowes",
      date: "Nov 2019 - May 2021",
      desc: "Worked as a Full Stack Java developer with Angular on Frontend",
      skills: [
        "Angular",
        "Java",
        "SpringBoot",
        "Postgres",
        "HTML",
        "CSS",
        "JavaScript",
        "AWS"
      ]
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFcIn8dRKK-jDptorbz0GLLs2993kCNa0V1OYGCHm9K-rHwQBrp8JAeNkxChJ2gKlDLxA&usqp=CAU",
      role: "Gradauate Assistant",
      company: "University Of Nevada, Las Vegas",
      date: "Aug 2017 - May 2019",
      desc: "Worked as a Graduate Assistant on tutoring bachelors student on Programming language like C++, Python, Java",
      skills: [
        "C++",
        "Java",
        "Python",
        "MYSQL", 
      ]
    },
    {
      id: 3,
      role: "Founder and Developer",
      company: "EduSewa Nepal",
      date: "Mar 2016 - Jul 2017",
      desc: "Started a Startup Comapny for providing solutions to educational institutes to use digital technology through web app and mobile app for records keeping and tracking with financial features as well.",
      skills: [
        "C++",
        "Java",
        "Python",
        "MYSQL", 
      ]
    },
    {
      id: 4,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8kT_g72odFxj1rI9YJ0Notw8lBPcrvRjmbD0RU-TnAQ&s",
      role: "Freelancer",
      company: "Upwork",
      date: "Aug 2014 - Jul 2017",
      desc: "Worked as a freelancer at Upwork to create multiple cross platform 2d games and few apps as per client request.",
      skills: [
        "C++",
        "Java",
        "Python",
        "MYSQL", 
      ]
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFcIn8dRKK-jDptorbz0GLLs2993kCNa0V1OYGCHm9K-rHwQBrp8JAeNkxChJ2gKlDLxA&usqp=CAU",
      school: "University of Nevada, Las Vegas",
      date: "Aug 2017 - May 2019",
      grade: "3.85 GPA",
      desc: "",
      degree: "Master's in Electrical and Computer Engineering",
    },
    {
      id: 1,
      img: "https://upload.wikimedia.org/wikipedia/en/thumb/5/54/Tribhuvan_University_logo.svg/1200px-Tribhuvan_University_logo.svg.png",
      school: "Tribhuvan University",
      date: "March 2012 - Aug 2016",
      grade: "3.7 GPA",
      desc: "Completed Bachelors in Electronics and Communication Engineering",
      degree: "Bachelor's in Electronics and Communication Engineering",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "NPtunes",
      date: "Jun 2015 - Jul 2017",
      description:
        "Nptunes is a digital platform for nepalese music where creators can upload their music and get royalty for every listen and download by customer through our portal.",
      image:
        "https://t4.ftcdn.net/jpg/03/89/68/41/360_F_389684193_WS7SeVuDxIlGmlWBLOM8wzPucZYog043.jpg",
      github: " https://github.com/suman-ghimire/Nptunes",
      tags: [
        "PHP",
        "Javascript",
        "Angular",
        "Css",
        "Java",
        "Sql",
      ],
      category: "projects",
    },
    {
      id: 1,
      title: "Sentiment Analysis",
      date: "Nov 2018",
      description:
        "Sentiment Analysis is a machine learning approach of identifying the sentiment like happy, sad, netural based on inputs.",
      image:
        "https://miro.medium.com/v2/resize:fit:1400/1*t_HKpbLn-ty1WTjuzR3ilA.png",
      github: " https://github.com/suman-ghimire/Sentiment-Analysis",
      tags: [
        "Python",
      ],
      category: "projects",
    },
    {
      id: 2,
      title: "A Survey on Bitcoin Cryptocurrency and its Mining",
      date: "18-20 December 2018",
      description:
        "In this paper, we survey various topics under Bitcoin such as blocks, blockchains, mining process and proof of work(PoW)",
      image:
        "https://www.researchgate.net/profile/Suman-Ghimire-5/publication/331040157/figure/fig5/AS:748818874241024@1555543740706/How-the-Bitcoin-Blockchain-Works.jpg",
        
      github: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=euYIgCUAAAAJ&citation_for_view=euYIgCUAAAAJ:u5HHmVD_uO8C",
      member: [
        {
          name: "Suman Ghimire",
          img: "https://scholar.googleusercontent.com/citations?view_op=medium_photo&user=euYIgCUAAAAJ&citpid=3",
          linkedin: "https://www.linkedin.com/in/suman-ghimire1/",
          github: "https://github.com/suman-ghimire",
        },
        {
          name: "Henry Selvaraj",
          img: "https://i1.rgstatic.net/ii/profile.image/272484293410836-1441976726559_Q512/Henry-Selvaraj.jpg",
        },
      ],
      tags: [
        "Bitcoin",
        "BlockChain",
        "Proof Of Work",
      ],
      category: "research_paper",
    },
    {
      id: 2,
      title: "Analysis of bitcoin cryptocurrency and its mining techniques",
      date: " December 2019",
      description:
        "In this thesis research paper, we actually mine the bitcoin using different techniques and compare the results to identify which is the effecient way of mining.",
      image:
        "https://www.researchgate.net/profile/Suman-Ghimire-5/publication/331040157/figure/fig1/AS:748818874245120@1555543740143/Bitcoin-system-vs-current-system.jpg",
        
      github: "https://scholar.google.com/citations?view_op=view_citation&hl=en&user=euYIgCUAAAAJ&citation_for_view=euYIgCUAAAAJ:UeHWp8X0CEIC",
      member: [
        {
          name: "Suman Ghimire",
          img: "https://scholar.googleusercontent.com/citations?view_op=medium_photo&user=euYIgCUAAAAJ&citpid=3",
          linkedin: "https://www.linkedin.com/in/suman-ghimire1/",
          github: "https://github.com/suman-ghimire",
        },
      ],
      tags: [
        "Bitcoin",
        "BlockChain",
        "Proof Of Work",
      ],
      category: "research_paper",
    },
    {
      id: 3,
      title: "Aqua Shade",
      description:
        "Shade path is a 2D Game where you need to avoid obstacles and collect points as much as possible.",    
      tags: [
        "C#",
        "Unity",
        "Photoshop",
        "Adobe Illustrator",
      ],
      category: "games",
    },
    {
      id: 4,
      title: "Land Survivor",
      description:
        "Land Survivor 2D Game where you need to shoot the enemies, collect various kits like bullet, shield, medicine and collect points as much as possible.",
      tags: [
        "C#",
        "Unity",
        "Photoshop",
        "Adobe Illustrator",
      ],
      category: "games",
    },
  ];